<template>
	<div class="auditor">
		<el-dialog width="60%" title="请选择用户" @open="init()"  :visible.sync="dialog" center append-to-body :close-on-click-modal="false" @close="close">
			  <el-row type="flex" class="row-bg" justify="center">
			    <el-form :inline="true" :model="member" class="demo-form-inline" >
			      <el-form-item label="姓名">
			        <el-input v-model="member.name" placeholder="姓名"></el-input>
			      </el-form-item>
			      <el-form-item label="手机号">
			        <el-input v-model="member.phone" placeholder="手机号"></el-input>
			      </el-form-item>
			      <el-form-item>
			        <el-button type="primary" @click="getmemberlist">查询</el-button>
			      </el-form-item>
			    </el-form>
			  </el-row>
			  <el-row>
				  <el-form :inline="true"  class="demo-form-inline" >
				  <el-form-item label="请选择用户:">
				  		<el-tag v-for="(tag,index) in multipleSelection" :key="tag.id" @close="handleClose(index)" closable class="mr-2">{{tag.name}}</el-tag>
						<el-button type="text"  class="ml-4" @click="submitmember">确定</el-button>
				  </el-form-item>
				  </el-form>
			  </el-row>
			  <!-- 表格 -->
			  <el-table
			      :data="users"
			      tooltip-effect="dark"
			      style="width: 100%"
				  :row-key="getRowKey"
				   ref="multipleTable"
				  @selection-change="handleSelectionChange"
			      >
			      <el-table-column
				    :reserve-selection="true"
				    align="center"
					type="selection"
			        width="55">
					<!-- <template slot-scope="scope"><el-checkbox v-model="multipleSelection"></el-checkbox></template> -->
			      </el-table-column>
			      <el-table-column
				    align="center"
			        label="ID"
			        width="120">
			        <template slot-scope="scope">{{ scope.row.id }}</template>
			      </el-table-column>
			      <el-table-column
				    align="center"
			        prop="name"
			        label="姓名"
			        width="120">
			      </el-table-column>
			      <el-table-column
				    align="center"
			        prop="phone"
			        label="手机号"
			        show-overflow-tooltip>
			      </el-table-column>
				  <el-table-column
				    align="center"
				    prop="deptName"
				    label="部门"
				    show-overflow-tooltip>
				  </el-table-column>
			    </el-table>
				<div style="display: flex;justify-content: center;"><el-pagination background layout="prev, pager, next" :total="total" class="mt-4" @current-change="handleCurrentChange"></el-pagination></div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name:'auditor',
		props:{
			innerVisible:Boolean,
		},
	  data() {
	    return {
			member:{name:'',phone:'',pageNum:1},
			total:0,  //总条数
			users: [],
			multipleSelection: [],
			dialog:this.innerVisible,
			toggleRowSelect:false,
	    };
	  },
	  mounted() {
		  this.getmemberlist();
		  this.multipleSelection=localStorage.getItem("auditorarr")?JSON.parse(localStorage.getItem("auditorarr")):[];
	  },
	  watch:{
		  innerVisible(newval,oldval){
			  this.dialog=newval;
		  }
	  },
	  methods: {
		  init(){
			console.log("开屏");
			this.getmemberlist();
			this.multipleSelection=localStorage.getItem("auditorarr")?JSON.parse(localStorage.getItem("auditorarr")):[];
		  },
		  handleSelectionChange(val) {  //多选框选中的值
			console.log("当前选中：",val);
			// 如果是反显选中操作 不做处理
			if(this.toggleRowSelect){
				return;
			}
			let newarr=[];
			this.multipleSelection.forEach((item,index)=>{
				if(!item.phone){
					newarr.push(item);
				}
			})
			console.log("多余的项",newarr)
			
		    this.multipleSelection = val;
			this.multipleSelection.push(...newarr);
		  },
		  handleClose(index){  //删除审核员
			this.toggleRowSelect=true;
			this.$refs.multipleTable.toggleRowSelection(this.multipleSelection[index],false);
			this.multipleSelection.splice(index,1);
			this.toggleRowSelect=false;
			 
		  },
		  getRowKey(row){
		           return row.id;
		  },
		  handleCurrentChange(val) {  //分页
				console.log("当前页：",val);
		        this.member.pageNum=val;
				this.getmemberlist();
		  },
		  getmemberlist(){	//获取人员列表
		  	const that = this;
		  	this.$api.memberlist(that.member).then(function (response) {
		  		if(response.code==0){
		  			console.log("人员列表",response.data);
		  			that.users = response.data.data;
		  			that.total=response.data.total;
					
					that.$nextTick(()=>{
						console.log("初次加载",that.$refs)
						that.toggleRowSelect =true;
						that.$refs.multipleTable &&that.users.forEach((row)=>{
							that.multipleSelection.forEach((it,index)=>{
								if(it.id==row.id){
									that.multipleSelection[index]=row;
								}
							})
							let selectRow = that.multipleSelection.find((item)=>item.id===row.id);
							that.$refs.multipleTable.toggleRowSelection(row,selectRow ? true : false);
						})
						that.toggleRowSelect = false;
					})
					
		  		}else{
		  			that.$vs.notify({
		  				  title:"提示",
		  				  color:'warning',
		  				  text:response.message,
		  				  position:'top-center'
		  			});
		  		}
		  	})
		  },
		  submitmember(){
			this.$emit("submitmember",this.multipleSelection);
			this.close();
		  },
		  close(){
			localStorage.removeItem("auditorarr");
			this.$emit("closediaglo");
		  },
	  },
		
	}
</script>

<style>
</style>
